import axios from 'axios';
import config from '../config';
// import * as LineLoginSSO from './line/sso-login-sdk.1504519110';
import securityService from './SecurityService';
export const SESSION_AUTH_TOKEN = 'authToken';

export class LocationService {

  public getLocations(): Promise<any> {
    let reqConfig = securityService.getAuthorizeHeaders();
    reqConfig = {
      ...reqConfig,
    }

    return axios.get(`/api/location/all`, reqConfig);
  }

  public getLocation(id: any): Promise<any> {
    let reqConfig = securityService.getAuthorizeHeaders();
    reqConfig = {
      ...reqConfig,
    }

    return axios.get(`/api/location/${id}`, reqConfig);
  }

  public saveLocation(location: any): Promise<any> {
    let reqConfig = securityService.getAuthorizeHeaders();
    reqConfig = {
      ...reqConfig,
    }

    return axios.put(`/api/location/${location.id}`, location, reqConfig)
  }

  public createLocation(location: any): Promise<any> {
    let reqConfig = securityService.getAuthorizeHeaders();
    reqConfig = {
      ...reqConfig,
    }

    return axios.post(`/api/location`, location, reqConfig)
  }

  public deleteLocation(id: number): Promise<any> {
    let reqConfig = securityService.getAuthorizeHeaders();
    reqConfig = {
      ...reqConfig
    }
    return axios.delete(`/api/location/${id}`, reqConfig);
  }

}

const locationService = new LocationService();
export default locationService;
